import { ReactNode } from 'react';
import { useEnabledFeatures } from '../hooks/enabled-features/use-enabled-features';

/**
 * Unmasks content for Datadog Session Replay when the `datadogUnmaskingEnabled`
 * feature flag is on. The component will unmask text except for values in inputs.
 */
export function Unmask({ children }: { children: ReactNode }) {
    const { datadogUnmaskingEnabled } = useEnabledFeatures();
    if (!datadogUnmaskingEnabled) return <>{children}</>;
    return (
        <div data-dd-privacy="mask-user-input" style={{ display: 'contents' }}>
            {children}
        </div>
    );
}

/**
 * Forces Datadog Session Replay to mask the wrapped content when the
 * `datadogUnmaskingEnabled` feature flag is on. Use this to re-mask a specific
 * element inside an `<Unmask>` boundary.
 */
export function Mask({ children }: { children: ReactNode }) {
    const { datadogUnmaskingEnabled } = useEnabledFeatures();
    if (!datadogUnmaskingEnabled) return <>{children}</>;
    return (
        <div data-dd-privacy="mask" style={{ display: 'contents' }}>
            {children}
        </div>
    );
}
